module.exports = __webpack_public_path__ + "img/manage-empty-cust-icons.d7daa63e.svg";